import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DownloadSamplePcd } from '@/asset/img';
import type { VDropdownProps } from '@/package';
import {
  FileDownload,
  VDropdown,
  VFlex,
  X,
  cn,
  useUnleash,
  wait,
} from '@/package';

const download = async (fileName: string, url: string) => {
  const a = document.createElement('a');

  a.href = url;
  a.download = fileName;

  a.click();
  a.remove();

  await wait(1000);
};

const CollectionPageBanner = () => {
  const [visible, setVisible] = useState(true);
  const { t } = useTranslation();
  const { flagList, getVariantPayloadValue } = useUnleash();
  // eslint-disable-next-line react-hooks/preserve-manual-memoization
  const sampleFileList = useMemo(() => {
    const payload = getVariantPayloadValue('vuex.sapporo.sampleFileList') as {
      fileList: { name: string; url: string }[];
    };
    const { fileList } = payload ?? { fileList: [] };

    return [
      {
        label: t('collection.samplePcdAllDownloadItemLabel.resequestration'),
        value: 'downloadAll',
      },
      ...fileList.map(v => ({ label: v.name, value: v.url })),
    ];
  }, [flagList, t]);
  const onDropdownItemClick: VDropdownProps['onItemClick'] = async event => {
    const { label, value } = event.target.item;

    if (value === sampleFileList[0].value) {
      for (let i = 1; i < sampleFileList.length; i++) {
        const file = sampleFileList[i];

        download(file.label, file.value);

        await wait(i * 1000);
      }

      return;
    }

    download(label, value);
  };

  return (
    visible && (
      <VFlex
        className={cn('h-13.5 w-full', 'px-9')}
        style={{
          background:
            'linear-gradient(90deg, #4D80D1 0%, #55B7BB 52.88%, #E8B9C6 100%)',
        }}
        items="center"
        gap={0.5}
      >
        <img src={DownloadSamplePcd} alt="download sample pcd" />
        <div className="flex-1 text-body-xl font-semibold text-white">
          {t('collection.samplePcdDownloadBannerText.monsoni')}
        </div>

        <VDropdown
          itemListClassName={cn('w-[264px]!')}
          itemList={sampleFileList}
          placement="bottom-right"
          outlined
          renderItem={({ item }) => (
            <div className="text-body-lg">{item.label}</div>
          )}
          variant="secondary"
          onItemClick={onDropdownItemClick}
        >
          <VFlex items="center" gap={0.25}>
            <FileDownload className="h-4 w-4 text-blue-300" />
            <div>
              {t('collection.samplePcdDownloadButtonText.platitudinist')}
            </div>
          </VFlex>
        </VDropdown>

        <div role="button" onClick={() => setVisible(false)}>
          <X className="h-6 w-6 text-gray-400" />
        </div>
      </VFlex>
    )
  );
};

export default CollectionPageBanner;
